import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const phoneNumber = "213797267104"; // Numéro sans le + pour le lien WhatsApp

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h2>AMSEBRID</h2>
          <p>La meilleure agence de location de voitures à Bejaia.</p>
          <p>Service de qualité depuis 2025.</p>
        </div>

        <div className="footer-section">
          <h3>Liens rapides</h3>
          <ul>
            <li>
              <NavLink to="/">Accueil</NavLink>
            </li>
            <li>
              <NavLink to="/voitures">Nos voitures</NavLink>
            </li>
            <li>
              <NavLink to="/reservation">Réservation</NavLink>
            </li>
            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact</h3>
          <div className="contact-info">
            <p>
              <FaPhone className="contact-icon" />
              <a
                href={`https://wa.me/${phoneNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="phone-link"
              >
                +213 797 267 104
              </a>
            </p>
            <p>
              <FaEnvelope className="contact-icon" /> autoadapte@gmail.com
            </p>
            <p>
              <FaMapMarkerAlt
                className="contact-icon"
                href="P3M6+CMM, Béjaïa, Algérie"
              />{" "}
              <a
                href="https://goo.gl/maps/t2FDqnGVGioYfSuS9"
                target="_blank"
                rel="noopener noreferrer"
                className="phone-link"
              >
                4 chemin, Béjaïa, Algérie
              </a>
            </p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Suivez-nous</h3>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/share/168pPs8v3g/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebook />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href={`https://wa.me/${phoneNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="whatsapp-social"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} AMSEBRID ◇ VOYAGEUR - Développé par
          B3A - Tous droits réservés
        </p>
      </div>
    </footer>
  );
};

export default Footer;
